import {REQUEST_METHOD_POST, allRequest, getRequest, postRequest} from '../../../../middlewares/api/actions';
import {getImportCsvUrl, getImportExcelWithSeqMappingUrl, getImportExcelWithSeqMappingWithValidationUrl, getUploadFileOnServerUrl, getImportCsvWithValidationUrl, CONVERT_FILE_STAND_ALONE_URL, getImportFieldExpressionCsvUrl, getDdbDataflowByCudeId} from '../../../../constants/urls';
import {getStringFromArtefactTriplet} from "../../../../utils/sdmxJson";
import { PATH_DATAFLOW_BUILDER_BY_CUBE_ID } from '../../../../constants/paths';

export const LOADER_CSV_FORM_CHANGE = 'LOADER_CSV_FORM_CHANGE';
export const LOADER_CSV_FORM_FILE_UPLOAD = 'LOADER_CSV_FORM_FILE_UPLOAD';
export const LOADER_CSV_FORM_SUBMIT = 'LOADER_CSV_FORM_SUBMIT';
export const LOADER_CSV_FORM_IGNORE_CONCURRENT_UPLOAD_CONFIRM_HIDE = 'LOADER_CSV_FORM_IGNORE_CONCURRENT_UPLOAD_CONFIRM_HIDE';
export const LOADER_CSV_FORM_SEQUENCE_MAPPING_SUBMIT = 'LOADER_CSV_FORM_SEQUENCE_MAPPING_SUBMIT';
export const LOADER_CSV_FORM_PLUGIN_CONVERT = 'LOADER_CSV_FORM_PLUGIN_CONVERT';
export const LOADER_PLUGIN_FILE_UPLOAD =  'LOADER_PLUGIN_FILE_UPLOAD';
export const LOADER_RESET_FIELDS = 'LOADER_RESET_FIELDS';
export const LOADER_SHOW_MODAL_REVIEW_DATAFLOWS = 'LOADER_SHOW_MODAL_REVIEW_DATAFLOWS';
export const LOADER_HIDE_MODAL_REVIEW_DATAFLOWS = 'LOADER_HIDE_MODAL_REVIEW_DATAFLOWS';
export const LOADER_UPLOAD_DATAFLOW_BUILDER = 'LOADER_UPLOAD_DATAFLOW_BUILDER';

const DATAFLOW_BUILDER_BY_CUBE_ID = PATH_DATAFLOW_BUILDER_BY_CUBE_ID;

export const changeLoaderCsvForm = fields => ({
  type: LOADER_CSV_FORM_CHANGE,
  fields
});


export const uploadLoaderCsvFormFile = (file, mappingCubeId, format) => {

  let fileFormData = new FormData();
  fileFormData.append('file', file);

  return ({
    format,
    ...postRequest(
      LOADER_CSV_FORM_FILE_UPLOAD,
      getUploadFileOnServerUrl(mappingCubeId),
      fileFormData,
      t => ({
        start: t('scenes.dataManager.loader.csvForm.messages.fileUpload.start'),
        success: t('scenes.dataManager.loader.csvForm.messages.fileUpload.success')
      })
    )
  });
};

export const submitLoaderCsvForm = (separator, delimiter, hasHeader, importType, cubeId, mappingId, filePath, tid, cubeCode, idMappingSpecialTimePeriod, embargo, refreshProdDf, checkFiltAttributes, ignoreConcurrentUpload, ccTriplet, ccFilePath, mode = null, deleteMode = false, hasMappingFieldExpressions = false) => ({
  ...getRequest(
    LOADER_CSV_FORM_SUBMIT,
    hasMappingFieldExpressions ?
    ccFilePath 
        ? (getImportFieldExpressionCsvUrl(separator, delimiter, hasHeader, importType, cubeId, mappingId, filePath, tid, idMappingSpecialTimePeriod, embargo, refreshProdDf, checkFiltAttributes, ignoreConcurrentUpload, null, mode, deleteMode, ccFilePath ))
        : (getImportFieldExpressionCsvUrl(separator, delimiter, hasHeader, importType, cubeId, mappingId, filePath, tid, idMappingSpecialTimePeriod, embargo, refreshProdDf, checkFiltAttributes, ignoreConcurrentUpload, getStringFromArtefactTriplet(ccTriplet), mode, deleteMode ))
      : ccFilePath 
      ? (getImportCsvWithValidationUrl(separator, delimiter, hasHeader, importType, cubeId, mappingId, filePath, tid, idMappingSpecialTimePeriod, embargo, refreshProdDf, checkFiltAttributes, ignoreConcurrentUpload, ccFilePath, mode))
      : (getImportCsvUrl(separator, delimiter, hasHeader, importType, cubeId, mappingId, filePath, tid, idMappingSpecialTimePeriod, embargo, refreshProdDf, checkFiltAttributes, ignoreConcurrentUpload, getStringFromArtefactTriplet(ccTriplet), mode, deleteMode )),
    t => ({
      start: t('scenes.dataManager.loader.csvForm.messages.submit.start'),
      success: t('scenes.dataManager.loader.csvForm.messages.submit.success')
    })
  ),
  reportFileNameId: cubeCode
});

export const onHideLoaderCsvFormIgnoreConcurrentUploadConfirm = () => ({
  type: LOADER_CSV_FORM_IGNORE_CONCURRENT_UPLOAD_CONFIRM_HIDE
});

export const submitLoaderCsvFormWithSeqMapping = (importType, seqMappingId, cubeCode, filePath, tid, refreshProdDf, embargo, ignoreConcurrentUpload, checkFiltAttributes, ccTriplet, resultItems,ccFileServerPath, pluginUid) => ({
  ...getRequest(
    LOADER_CSV_FORM_SEQUENCE_MAPPING_SUBMIT,
    ccFileServerPath
      ? (getImportExcelWithSeqMappingWithValidationUrl(importType, seqMappingId, filePath, tid, refreshProdDf, embargo, ignoreConcurrentUpload, checkFiltAttributes, ccFileServerPath, pluginUid))
      : (getImportExcelWithSeqMappingUrl(importType, seqMappingId, filePath, tid, refreshProdDf, embargo, ignoreConcurrentUpload, checkFiltAttributes, getStringFromArtefactTriplet(ccTriplet), pluginUid)),
    t => ({
      start: t('scenes.dataManager.loader.csvForm.messages.submit.start'),
      success: t('scenes.dataManager.loader.csvForm.messages.submit.success')
    })
  ),
  reportFileNameId: cubeCode,
  resultItems: resultItems
});


export const uploadLoaderPluginFormFile = (pluginUid, file, mappingCubeId, format, transformFile, processFile, action = LOADER_PLUGIN_FILE_UPLOAD) => {

  let fileFormData = new FormData();
  fileFormData.append('file', file);

  let transformFileFormData = new FormData();
  if (transformFile) transformFileFormData.append('file', transformFile);

  let processFileFormData = new FormData();
  if (processFile) processFileFormData.append('file', processFile);

  const areAllConfigFilesPresent = transformFile && processFile;
  const isAtLeastOneConfigFilePresent = transformFile || processFile;

  if (isAtLeastOneConfigFilePresent) {
    return allRequest(
        action,
        areAllConfigFilesPresent ? [REQUEST_METHOD_POST, REQUEST_METHOD_POST, REQUEST_METHOD_POST] : [REQUEST_METHOD_POST, REQUEST_METHOD_POST],
        areAllConfigFilesPresent ? [getUploadFileOnServerUrl(mappingCubeId, pluginUid, "input"), getUploadFileOnServerUrl(mappingCubeId, pluginUid, "transform"), getUploadFileOnServerUrl(mappingCubeId, pluginUid, "process")] :
            [getUploadFileOnServerUrl(mappingCubeId, pluginUid, "input"), transformFile ? getUploadFileOnServerUrl(mappingCubeId, pluginUid, "transform") : getUploadFileOnServerUrl(mappingCubeId, pluginUid, "process")],
        areAllConfigFilesPresent ? [fileFormData, transformFileFormData, processFileFormData] :
            [fileFormData, transformFile ? transformFileFormData : processFileFormData],
        null,
        null
    );
    } else {
      return postRequest(
          action,
          getUploadFileOnServerUrl(mappingCubeId, pluginUid, "input"),
          fileFormData,
          t => ({
              start: t('scenes.utilities.plugin.modal.input.messages.submit.start'),
              success: t("scenes.utilities.plugin.modal.input.messages.submit.success")
          })
      );
  }
};

export const submitLoaderPluginConvertAction = (pluginUid, fileServerPath, transformFileServerPath, processFileServerPath, lang, outputExtension, dllName, action, mode, idCube, deleteFile) => 
  postRequest(
    action,
    CONVERT_FILE_STAND_ALONE_URL,
    {PluginId: pluginUid, InputFilePath: fileServerPath, MappingPath: transformFileServerPath, ProcessPath: processFileServerPath, Lang: lang, OutputExtension: outputExtension, DllName: dllName, Mode: mode, IdCube:idCube, DeleteInputFile:deleteFile, CheckTransformFiles:false},
    t =>({
      start: t('scenes.utilities.plugin.modal.output.messages.conversion.start'),
      success: t("scenes.utilities.plugin.modal.output.messages.conversion.success")
    })
  );


export const convertLoaderPluginToCsv = (pluginUid, fileServerPath, transformFileServerPath, processFileServerPath, lang, outputExtension, dllName, idCube, deleteFile) => 
  submitLoaderPluginConvertAction(pluginUid, fileServerPath, transformFileServerPath, processFileServerPath, lang, outputExtension, dllName, LOADER_CSV_FORM_PLUGIN_CONVERT, 2, idCube, deleteFile);

export const resetFields = () => ({
    type: LOADER_RESET_FIELDS
})

export const onModalReviewDataflows = () => ({
  type: LOADER_SHOW_MODAL_REVIEW_DATAFLOWS
})

export const hideModalReviewDataflows = () => ({
  type: LOADER_HIDE_MODAL_REVIEW_DATAFLOWS
})

export const uploadDataflowBuilder = (id) => ({
  type: LOADER_UPLOAD_DATAFLOW_BUILDER,
  action: window.open("./#" + DATAFLOW_BUILDER_BY_CUBE_ID + id, '_self'),
})

